import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProductCard from "components/cards/ProductCard";
import { asPrice } from "utils/text";
import { Link } from "react-router-dom";

export default ({ relatedProducts }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} className={classes.products}>
      <Grid item xs={12}>
        <Typography component={"h2"} align="center" className={classes.mayText}>
          You May Also Like
        </Typography>
      </Grid>
      {relatedProducts.map((product) => (
        <Grid item xs={12} md={6} lg={4} key={product.id}>
          <div className={classes.card}>
            <div className={classes.imageContainer}>
              <img
                src={product.image}
                alt="product image"
                className={classes.productImage}
              />
            </div>
            <div className={classes.line} />
            <h6
              component="h2"
              style={{
                fontSize: "18px",
                margin: "11px 0px",
              }}
              class
            >
              {product.title}
            </h6>
            <div className={classes.price}>
              <span class="value">{asPrice(product.price)}</span>
            </div>
            <Button
              variant="contained"
              fullWidth
              color="primary"
              className={classes.btn}
              component={Link}
              to={`/shop/product/${product.id}`}
            >
              Shop Now
            </Button>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    border: "1px solid #E6EAEE",
    padding: 24,
  },
  btn: {
    background: "#05C1FF !important",
    color: "white !important",
  },
  line: {
    height: 2,
    marginBottom: 10,
    background: "#e9ecf0",
  },
  products: {
    width: "80%",
    margin: "auto",
    marginTop: 40,
  },
  mayText: {
    color: "#354052",
    fontSize: "24px",
    fontWeight: 600,
  },
  imageContainer: {
    height: "182px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  productImage: {
    maxWidth: "100%",
    width: "auto",

    maxHeight: "100%",
    height: "auto",
  },
  price: {
    color: "#47caff",
    marginBottom: 20,
    fontSize: 18,
    fontWeight: 700,
  },
  memberPrice: {
    color: theme.palette.text.disabled,
    fontSize: 14,
  },
  Button: {
    fontSize: 14,
    fontWeight: 500,
    textTransform: "capitalize",
  },
}));
